import { Link } from "react-router-dom";

export default function Home() {
  return (
    <>
      <section className="hero">
        <div className="container">
          <h1>Peer Support for Seniors: End Loneliness</h1>
          <p className="lead">
            With over 15 million seniors living alone, the loneliness epidemic
            has become a pressing issue. MyJava.ai fosters connection through
            an AI peer support system that helps older adults build meaningful,
            empathetic friendships — accessible from any phone or smart speaker.
          </p>
          <div className="cta-row">
            <Link to="/pilot" className="btn">Join the pilot</Link>
            <a href="#what-we-do" className="btn btn-secondary">Learn more</a>
          </div>

          <div className="video-frame">
            <iframe
              src="https://player.vimeo.com/video/1070463798?h=d2238bbfcd&autoplay=1&loop=1&autopause=0&muted=1&title=0&byline=0&portrait=0&controls=0"
              title="MyJava.ai introduction"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              loading="lazy"
            />
          </div>
        </div>
      </section>

      <section className="section" id="what-we-do">
        <div className="container">
          <h2>MyJava.AI</h2>
          <p>
            The only effective loneliness solution is to make friends — and
            this doesn't necessarily come from a doctor, social worker,
            therapist, or family member. It's about fostering empathy-based
            friendships among peers.
          </p>
          <p>
            MyJava.ai delivers AI peer support through proven, content-rich
            programming on virtual telephone and digital platforms. These
            recurring, intimate group discussions are facilitated by our AI
            host, Bella, and built on more than ten years of in-person research
            with senior living organizations.
          </p>
          <p>
            High-tech for low-tech users: connect by phone, smart speaker, or
            home care device. No app to download.
          </p>
        </div>
      </section>

      <section className="section-tight">
        <div className="container">
          <div className="grid three">
            <div className="card">
              <h3>Voice-first access</h3>
              <p>
                Join a session by simply picking up the phone. No app, no
                login, no learning curve.
              </p>
            </div>
            <div className="card">
              <h3>Bella, your AI facilitator</h3>
              <p>
                Bella keeps every voice heard, drawing in quieter participants
                and helping the group find common ground.
              </p>
            </div>
            <div className="card">
              <h3>Proven curriculum</h3>
              <p>
                Built on a decade of peer-support research deployed at over
                2,000 senior living organizations across North America.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container" style={{ textAlign: "center" }}>
          <h2>Talk with Eric</h2>
          <p>
            If you're a health plan, provider, CBO, foundation, investor, or
            anyone dedicated to solving loneliness, we'd love to hear from you.
          </p>
          <p>
            <a href="tel:+16479305894" className="btn">‭+1 (647) 930-5894‬</a>
          </p>
        </div>
      </section>
    </>
  );
}
